module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1144.244b7d27.png";